/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import Content from '@component/common/content';
import * as size from '@constant/size';
import * as color from '@constant/color';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import SideTab from '@component/moashelf/navigator/side-tab';
import BottomTab from '@component/moashelf/navigator/bottom-tab';
import IconBlock from 'component/common/block/icon-block';
import Avatar from '@component/common/avatar';
import { actions as authActions } from '@store/slice/auth-slice';
import { actions as navigationActions } from '@store/slice/navigation-slice';
import Subscriptions from '@component/moashelf/newsletter/subscriptions';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import HeaderContainer from '@component/common/architecture/header/header-container';
import TextBlock from 'component/common/block/text-block';
import { useFindMe } from '@hook/auth/useAuth';
import { IMoashelfMenu } from '@datatype/moashelf/type';

const HEADER_ICON_WIDTH = '30px';

const HEADER_CONTAINER_DESIGN = {
  left: IS_IYAGIGO_MOBILE_VIEW ? '0px' : size.WEB_SIDE_WIDTH,
  right: '0px',
  height: size.MOBILE_HEADER_HEIGHT,
  align: IS_IYAGIGO_MOBILE_VIEW ? 'around' : 'right',
  backgroundColor: color.GRAY_4,
} as const;

const AVATAR_DESIGN = {
  text: { size: '14px' },
  position: { top: '0px', right: '15px' },
  avatarSize: HEADER_ICON_WIDTH,
};

const HEADER_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2 },
  box: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' },
} as const;

const SubscriptionPage: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  const me = useFindMe();
  const isMobileSideTab = useTypedSelector((state) => state.rootReducer?.navigationReducer?.isMobileSideTab) ?? false;
  const subscriptionMenu = useTypedSelector(
    (state) => state.rootReducer?.navigationReducer?.moashelf?.subMenu,
  ) as IMoashelfMenu['subscription'] ?? null;

  const username = me?.data.username;
  const initial = `${username?.[0] ?? null}`;

  const handleAvatarClick = () => dispatch(authActions.openMyPage());
  const handleMenuClick = () => dispatch(navigationActions.openMobileSideTab());
  return (
    <>
      {IS_IYAGIGO_MOBILE_VIEW ? (
        <>
          {isMobileSideTab && <SideTab />}
          <HeaderContainer design={HEADER_CONTAINER_DESIGN}>
            <IconBlock
              icon='menu'
              design={{
                icon: { size: 'medium' },
                box: { width: HEADER_ICON_WIDTH, left: '15px' },
              }}
              click={{ handler: handleMenuClick }}
            />
            <TextBlock text={'구독관리'} design={HEADER_TEXT_DESIGN} />
            <Avatar name={initial} design={AVATAR_DESIGN} onClick={handleAvatarClick} />
          </HeaderContainer>
          <Content top={size.MOBILE_HEADER_HEIGHT} bottom={size.MOBILE_BOTTOM_HEIGHT}>
            <Subscriptions mode={subscriptionMenu} />
          </Content>
          <BottomTab />
        </>
      ) : (
        <>
          <SideTab />
          <HeaderContainer design={HEADER_CONTAINER_DESIGN}>
            <TextBlock text={'구독관리'} design={HEADER_TEXT_DESIGN} />
            <Avatar name={initial} design={AVATAR_DESIGN} onClick={handleAvatarClick} />
          </HeaderContainer>
          <Content left={size.WEB_SIDE_WIDTH} top={size.MOBILE_HEADER_HEIGHT} bottom={'0px'}>
            <Subscriptions mode={subscriptionMenu} />
          </Content>
        </>
      )}
    </>
  );
};

export default SubscriptionPage;
